<template>
  <div>
    <b-modal v-model="modalSubmitPO" title="Change to Processing SO">
      <!-- Alert before Delete PO-->
      <b-container>
        <b-row>
          <b-col cols="12" >
            <div class="d-flex">
              Are you sure want to complete this {{poNumber[0]}} ?
            </div>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <b-button variant="success" class="ml-1" @click="confirmPO">Confirm</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="disableButton" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Processing Purchase Order</p>
      </div>
    </b-modal>
    <b-modal v-model="modalSapError" title="SAP Error" hide-footer centered>
      <div class="d-flex flex-column align-items-center">
        <p class="text-center">SO creation in SAP fail. Counter staff has beennotified. No action required at your side. Counter staff will settle this issue</p>
        <div class="d-flex justify-content-center mt-2">
          <b-button variant="primary" @click="handleSapErrorClose">OK</b-button>
        </div>
      </div>
    </b-modal>
    <b-card no-body>
      <b-card-body title="Detail Kiosk PO">
        <b-col cols="12">
          <div class="mb-2">
            <b-button
            @click="goBack"
            type="submit"
            variant="primary"
            class="mr-1"
            >Back To Kiosk PO List</b-button
          >
            <b-button
              v-if="purchase.counterID"
              @click="goToCounter"
              variant="info"
              class="mr-1"
            >Back To Counter</b-button>
            <b-button
              v-if="purchase.orderStatus === 'Editing'"
              @click="editPO"
              variant="warning"
              class="mr-1"
            >Edit PO</b-button>
            <b-button
               v-if="purchase.items.every(item => item.status === 'Safe' || item.status === 'Replacement Item Safe') && purchase.orderStatus === 'Checking'"
              @click="modalSubmitPO = true"
              variant="success"
              class="mr-1"
            >Submit PO</b-button>
            <b-button
              v-if="purchase.orderStatus === 'Editing'"
              @click="showCancelModal = true"
              variant="outline-danger"
              class="mr-1"
            >Cancel PO</b-button>
            
          </div>
          <b-row>
            <!-- ================================ -->
            <b-col cols="6">
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Order</label>
                  <p class="font-weight-bold">{{ poNumber[0] }}</p>
                </div>
              </b-row>
              <b-row v-if="purchase.customerPO && purchase.customerPO !== ''">
                <div class="d-flex flex-column">
                  <label>Customer PO</label>
                  <p class="font-weight-bold">{{ purchase.customerPO }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Sales Order</label>
                  <p class="font-weight-bold">{{ (purchase.sapSo != ''&&purchase.sapSo != null) ? purchase.sapSo : 'Not Set' }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Payment Type</label>
                  <p class="font-weight-bold">
                    {{ displayPaymentType(purchase.paymentType) }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Distribution Channel</label>
                  <p class="font-weight-bold">{{ purchase.distributionChannel }}</p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Order Status</label>
                  <p class="font-weight-bold">{{ purchase.orderStatus === 'PO Fail' ? 'Admin Review' : (purchase.orderStatus == '' ? 'Created' : purchase.orderStatus)}}</p>
                  <b-button 
                    v-if="purchase.orderStatus === 'PO Fail'"
                    variant="warning"
                    size="sm"
                    class="mt-1 mb-1"
                    @click="resendKioskPO"
                    :disabled="loading"
                  >
                    <b-spinner small v-if="loading"></b-spinner>
                    Resend PO
                  </b-button>
                  <div v-if="purchase.orderStatus === 'Checking'" class="mt-2">
                    <b-progress 
                      :value="checkingProgress.checked" 
                      :max="checkingProgress.total"
                      show-progress
                      animated
                      class="mb-1"
                    ></b-progress>
                    <small class="text-muted">
                      {{ checkingProgress.checked }} of {{ checkingProgress.total }} items checked
                    </small>
                  </div>
                </div>
              </b-row>
              <b-row>
                <div
                  v-if="purchase.orderStatus === 'PO Fail'"
                  class="mb-1"
                >
                  <span style="color:red">*{{ purchase.errorMessageSAP }}</span>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Purchase Date</label>
                  <p class="font-weight-bold">
                    {{ dates(purchase.updatedAt) }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Phone</label>
                  <p class="font-weight-bold">
                    {{ purchase.customerDetail.phone }}
                  </p>
                </div>
              </b-row>
              <b-row>
                <div class="d-flex flex-column">
                  <label>Email</label>
                  <p class="font-weight-bold">
                    {{ purchase.customerDetail.email }}
                  </p>
                </div>
              </b-row>
            </b-col>

            <b-col cols="6">
              <b-row>
                <div
                  class="d-flex flex-column"
                  v-if="purchase.deliveryType === 'End Customer'"
                >
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      purchase.customerDetail.type === "Company"
                        ? purchase.customerDetail.companyName
                        : `${purchase.customerDetail.firstName} ${purchase.customerDetail.lastName}`
                    }}
                  </p>
                </div>

                <div
                  class="d-flex flex-column"
                  v-if="purchase.deliveryType === 'Self Collect'"
                >
                  <label>Customer Name</label>
                  <p class="font-weight-bold">
                    {{
                      purchase.customerDetail.firstName === ""
                        ? "Not Set Up"
                        : `${purchase.customerDetail.firstName} ${purchase.customerDetail.lastName}`
                    }}
                  </p>
                </div>
              </b-row>
              <!-- <b-row>
                <div class="d-flex flex-column">
                  <label>PO Created by</label>
                  <p class="font-weight-bold" v-if="this.purchase.createdBy === ''">
                    Not Set Up
                  </p>
                  <p class="font-weight-bold" size="md" v-if="this.purchase.createdBy !== ''">
                    {{ purchase.createdBy }}
                  </p>
                </div>
              </b-row> -->
              <b-row>
                <div class="d-flex flex-column">
                  <label>Remarks</label>
                  <p class="font-weight-bold">
                    {{ purchase.remarks }}
                  </p>
                </div>
              </b-row>
            </b-col>
          </b-row>
          <!-- ============================= -->
          <!-- <b-row>

            <b-col cols="6"> </b-col>

            <b-col cols="6">
              

              
            </b-col>
          </b-row> -->
          <!-- ================================ -->
          <!-- <b-row>
            <b-col cols="6"> </b-col>
            <b-col cols="6">
              
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6"> </b-col>

            <b-col cols="6">
             
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6"> </b-col>
            <b-col cols="6"> </b-col>
          </b-row> -->

          <b-row style="margin-top:25px;">
            <b-col cols="12">
              <div class="table-responsive">
                <b-table
                  :items="purchase.items"
                  :fields="tableFields"
                  bordered
                  responsive
                >
                  <template #cell(no)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(item)="data">
                    {{ getItemDetails(data.item).model }}
                  </template>
                  <template #cell(quantity)="data">
                    {{ getItemDetails(data.item).qty }}
                  </template>
                  <template #cell(status)="row">
                    <b-badge
                      :variant="row.item.status === 'Replacement Item Safe' ? 'warning' : 
                              row.item.status === 'Out of Stock' ? 'danger' : 
                              'secondary'"
                    >
                      {{!row.item.status ? "Checking Stock" :( row.item.status == "Safe" ? "Available" : (row.item.status == "Replacement Item Safe" ? 'Replacement Available' : row.item.status)) }}
                    </b-badge>
                  </template>
                  <template #cell(unitPrice)="data">
                    $ {{ formatter(getItemDetails(data.item).price) }}
                  </template>
                  <template #cell(discountAmount)="data">
                    $ {{ formatter(getItemDetails(data.item).discountAmount) }}
                  </template>
                  <template #cell(discount)="data">
                    {{ getItemDetails(data.item).discountPercentage }}%
                  </template>
                  <template #cell(totalPrice)="data">
                    $ {{ subtotalPrice(data.item) }}
                  </template>
                </b-table>
              </div>
              
              <b-card class="pt-1">
                <!-- <b-row>
                  <b-col class="text-right font-weight-bold">Total Discount:</b-col>
                  <b-col cols="12" md="2" class="text-right">{{ calculateTotal.totalDiscount }}%</b-col>
                </b-row> -->
                <b-row>
                  <b-col class="text-right font-weight-bold">Subtotal after discount:</b-col>
                  <b-col cols="12" md="2" class="text-right">$ {{ formatter(calculateTotal.subTotal) }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right font-weight-bold">GST {{ currentGST.value }}%:</b-col>
                  <b-col cols="12" md="2" class="text-right">$ {{ formatter(calculateTotal.totalGST) }}</b-col>
                </b-row>
                <b-row class="mb-0">
                  <b-col class="text-right font-weight-bold">Total Price:</b-col>
                  <b-col cols="12" md="2" class="text-right font-weight-bold">$ {{ formatter(calculateTotal.grandTotal) }}</b-col>
                </b-row>
              </b-card>
              
              
            </b-col>
          </b-row>
        </b-col>
      </b-card-body>
    </b-card>

    <!-- Status Modal -->
    <b-modal
      v-model="showStatusModal"
      :title="statusModalTitle"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
      ok-title="Close"
    >
      <div class="text-center">
        <p v-if="checkingProgress.checked == checkingProgress.total && purchase.items.every(item => item.status === 'Safe' || item.status === 'Replacement Item Safe')">
          ✅ All items have been successfully checked by the warehouse.<br />
          You may now proceed to <strong>Submit PO</strong> for the next step.
        </p>
        <p v-else>{{ statusModalMessage }}</p>

        <p v-if="purchase.orderStatus === 'Processing SO'">
          Please create the DO inside SAP as this customer is a Dealer (Credit Customer)
        </p>

        <b-spinner v-if="showSpinner && checkingProgress.checked !== checkingProgress.total" class="my-3" label="Loading..."></b-spinner>

        <div v-if="purchase.orderStatus === 'Checking'" class="mt-3">
          <b-progress 
            :value="checkingProgress.checked" 
            :max="checkingProgress.total"
            show-progress
            animated
            class="mb-2"
          ></b-progress>
          <small class="text-muted">
            {{ checkingProgress.checked }} of {{ checkingProgress.total }} items checked
          </small>
        </div>
        <div v-if="purchase.orderStatus === 'Editing'" class="mt-3">
          <b-button variant="warning" @click="editPO()">Go to Edit PO</b-button>
        </div>
        <div v-if="purchase.items.every(item => item.status === 'Safe' || item.status === 'Replacement Item Safe') && purchase.orderStatus === 'Checking'" class="mt-3">
          <b-button 
            variant="success"
            @click="modalSubmitPO = true"
          >
            Submit PO
          </b-button>
        </div>
      </div>
    </b-modal>


    <!-- Cancel Modal -->
    <b-modal
      v-model="showCancelModal"
      title="Cancel Purchase Order"
      centered
      hide-header-close
      @ok="cancelPO"
      ok-title="Confirm"
      ok-variant="danger"
      cancel-title="Close"
    >
      <div class="text-center">
        <p>Are you sure you want to cancel this purchase order?</p>
        <p class="text-danger font-weight-bold">This action cannot be undone.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { userAccess, dateFormat, dateFormatFullWithSecond } from "@/utils/utils";
import stepProgressDaikin from '@/components/StepProgressDaikin.vue'
import { logo, footer,header } from "./daikin-po-img-base64.js";
import { mapGetters, mapActions, mapState } from "vuex";

import * as pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";

export default {
  components: {
    stepProgressDaikin
  },
  props: ["id","from"],
  data() {
    return {
      doFields: [
        { key: "sapDo", label: "DO Number" },
        { key: "sapInvoice", label: "Invoice Number" },
        { key: "status", label: "Status" },
      ],
      itemFields: [
        { key: "model", text: "Item Model" },
        { key: "qty", text: "Qty" },
        { key: "price", text: "Price" },
        // { key: "rejectedQty", text: "Rejected Qty" },
        // { key: "rejectionReason", text: "Reason" },
      ],
      tableFields: [
        { key: "no", label: "No" },
        { key: 'item', label: 'Item' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'status', label: 'Status' },
        { key: 'unitPrice', label: 'Unit Price' },
        { key: 'discount', label: 'Discount' },
        { key: 'discountAmount', label: 'Discount Amount' },
        { key: 'totalPrice', label: 'Total Price' }
      ],
      doList: [],
      loading: false,
      refreshInterval: null,
      showCancelModal: false,
      disableButton: false,
      modalSubmitPO: false,
      modalSapError: false,
    };
  },
  methods: {
    ...mapActions({
      addSaleKiosk: "sales/addSaleKiosk"
    }),
    handleSapErrorClose() {
      this.modalSapError = false;
    },
    goBack(){
      this.$router.go(-1);
    },
    goToCounter() {
      this.$router.push({
        name: 'counter-view',
        params: { id: this.purchase.counterID }
      });
    },
    editPO() {
      var id = this.id
      this.$router.push({
        name: 'kiosk-po-edit',
        params: { idKioskPO: id }
      });
    },
    startAutoRefresh() {
      // Clear any existing interval first to prevent multiple intervals
      this.clearRefreshInterval();
      
      // Set new interval to refresh data every 10 seconds
      this.refreshInterval = setInterval(() => {
        this.fetchPurchaseData();
      }, 5000);
    },
    clearRefreshInterval() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    async fetchPurchaseData() {
      try {
        await this.$store.dispatch("purchase/detailPurchase", {
          id: this.id,
        });

        if(this.purchase.createdAt && this.currentGST.value == 0){
          var purchaseDate = new Date(this.purchase.createdAt)
          await this.$store.dispatch("GST/getCurrentGST", { date: purchaseDate })
        }
        
        // After fetching purchase data, update DO list if sapSo exists
        if (this.purchase && this.purchase.sapSo) {
          this.getDOList(this.purchase.sapSo);
        }
      } catch (err) {
        console.log({ err });
      }
    },
    getItemDetails(item) {
      const hasReplacement = item.availableReplacementQty != 0 && item.availableReplacementQty;
      const price = hasReplacement ? parseFloat(item.priceReplacement.$numberDecimal) : parseFloat(item.price.$numberDecimal);
      const qty = hasReplacement ? (item.updatedReplacementQty ?? item.availableReplacementQty) : (item.updatedQty ?? (item.availableQty ? item.availableQty : item.qty));
      const discountPercentage = hasReplacement ? (item.unitDiscountReplacement ?? item.unitDiscount) : item.unitDiscount ||0;
      const discountAmount = price * (discountPercentage / 100)*qty;
      const totalBeforeDiscount = price * qty;
      const totalAfterDiscount = totalBeforeDiscount - (totalBeforeDiscount * (discountPercentage / 100));
      
      return {
        model: hasReplacement ? item.replacementItem.itemModel : item.model,
        price: price,
        qty: qty,
        discountPercentage: discountPercentage,
        discountAmount: discountAmount,
        hasReplacement: hasReplacement,
        totalPrice: totalAfterDiscount
      };
    },
    subtotalPrice(item){
      return this.formatter(this.getItemDetails(item).totalPrice);
    },
    sapStatus(status){
      switch(status) {
        case 'A':
          return 'Ready'
        case 'B': 
          return 'Partially processed'
        case 'C':
          return 'Completely processed'
        case 'D':
          return 'Canceled'
        default:
          return `Unknown Status ${status}`
      }
    },
    remarksFormat(remarkString){
      if(remarkString==undefined){
        return ["",""]
      }
      var parsed= remarkString.split('\n');
      var lineOne= (parsed[0]==undefined)?"":parsed[0];
      var lineTwo= (parsed[1]==undefined)?"":parsed[1];
      
      return [lineOne,lineTwo]
    },
    dates(date) {
      return dateFormat(date);
    },
    datesWithTime(date){
      return dateFormatFullWithSecond(date)
    },
    customerName(purchase) {
      if (purchase.customer) {
        return purchase.customerDetail.nameFirst + " " + purchase.customerDetail.nameLast;
      } else {
        return (
          purchase.customerDetail.firstName +
          " " +
          purchase.customerDetail.lastName
        );
      }
    },
    formatter(value) {
      var number = value;
      if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    async getDOList(sapSo) {
      //return [{sapDo:1,sapInvoice:1}]
      var filterDO = await this.$store.dispatch("delivery/getDeliveryOrder",{sapSo:'0000'+sapSo})
        if(filterDO.data.length<=0){
          console.info("undefined")
          this.doList=[]
          return
        }

        var jData = filterDO.data.map((value)=>{
          return {
            id:value._id,
            sapDo:value.sapDo,
            sapInvoice:value.sapInvoice,
            status:value.status
          }
        })
        console.info('data ',jData)
        console.info('filterDO ',filterDO.data)
        this.doList=jData
        return
      
      
    },
    discountAmountCalculation(data){
      //**
      // expected data {item.qty} */
      return this.getItemDetails(data).discountAmount;
    },
    toSales() {
      var sapSo = this.purchase.sapSo;
      var filterSO = this.salesOrders.find((x) => {
        return x.sapSo === sapSo;
      });
      this.$router.push({
        name: "sales-order-detail",
        params: { idSales: filterSO._id },
      });
    },
    toDelivery(doDetail) {
      this.$router.push({
        name: "warehouse-detail-delivery",
        params: { id: doDetail.id, from: "other" },
      });
    },
        
    async printPO() {
      this.loading = true;
      try {
        var customerName = this.purchase.customerDetail.type === "Company"
          ? this.purchase.customerDetail.companyName
          : `${this.purchase.customerDetail.firstName} ${this.purchase.customerDetail.lastName}`;
        
        let docDefinition = {
          pageMargins: [70, 120, 70, 70],
          header: function(currentPage, pageCount, pageSize) {
            return [
              {
                image: `${header}`,
                alignment: "center",
                width: 520,
                margin: [0, 50, 0, 0],
              },
            ];
          },
          footer: function(currentPage, pageCount) {
            return [
              {
                image: `${footer}`,
                alignment: "center",
                width: 600,
                margin: [0, 0, 0, 50],
              },
            ];
          },
          content: [
            { text: 'Online Purchase Order to Daikin', style: 'header' },
            { text: '\n' },
            {
              layout: 'noBorders',
              table: {
                widths: ['20%', '1%', '79%'],
                headerRows: 1,
                body: [
                  [
                    { text: 'Customer PO', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.poNumber[1], fontSize: 10 }
                  ],
                  [
                    { text: 'Online PO Ref:', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.poNumber[0], fontSize: 10 }
                  ],
                  [
                    { text: 'Fulfillment Type', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.orderType, fontSize: 10 }
                  ],
                  [
                    { text: 'SO Status', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.sapStatus(this.purchase.sapStatus), fontSize: 10 }
                  ],
                  [
                    { text: 'Purchase Date', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.dates(this.purchase.updatedAt), fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Date', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.dates(this.purchase.deliveryDate), fontSize: 10 }
                  ],
                  [
                    { text: 'Payment Type', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.displayPaymentType(this.purchase.paymentType), fontSize: 10 }
                  ],
                  [
                    { text: 'Email', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.deliveryEmail, fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Type', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.deliveryType, fontSize: 10 }
                  ],
                  [
                    { text: 'Customer Name', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: customerName, fontSize: 10 }
                  ],
                  [
                    { text: 'Delivery Address', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: [
                      this.purchase.customerDetail.address,
                      this.purchase.customerDetail.address2,
                      this.purchase.customerDetail.address3,
                      this.purchase.deliveryAddress,
                      this.purchase.deliveryAddress2,
                      this.purchase.deliveryAddress3
                    ].filter(Boolean).join('\n'), fontSize: 10 }
                  ],
                  [
                    { text: 'Remarks', fontSize: 10 },
                    { text: ':', fontSize: 10 },
                    { text: this.purchase.remarks || '', fontSize: 10 }
                  ]
                ]
              }
            },
            { text: '\n' },
            { text: 'Item Details', style: 'subheader' },
            {
              table: {
                widths: ['*', 50, 50, 50, 50, '*'],
                headerRows: 1,
                body: [
                  [
                    { text: 'Model', style: 'tableHeader' },
                    { text: 'Unit Price', style: 'tableHeader' },
                    { text: 'Qty', style: 'tableHeader' },
                    { text: 'Discount', style: 'tableHeader' },
                    { text: 'Discount Amount', style: 'tableHeader' },
                    { text: 'Total Price', style: 'tableHeader' }
                  ],
                  ...this.purchase.items.map(item => {
                    const details = this.getItemDetails(item);
                    let itemDescription = item.model;
                    if (item.description) {
                      itemDescription += ` - ${item.description}`;
                    }
                    if (details.hasReplacement && item.replacementItem) {
                      itemDescription += `\nReplacement: ${item.replacementItem.itemModel}`;
                      if (item.replacementItem.description) {
                        itemDescription += ` - ${item.replacementItem.description}`;
                      }
                    }
                    return [
                      { text: itemDescription, fontSize: 9 },
                      { text: `$${this.formatter(details.price)}`, fontSize: 9 },
                      { text: details.qty.toString(), fontSize: 9 },
                      { text: `${details.discountPercentage}%`, fontSize: 9 },
                      { text: `$${this.formatter(details.discountAmount)}`, fontSize: 9 },
                      { text: `$${this.formatter(details.totalPrice)}`, fontSize: 9 }
                    ];
                  })
                ]
              }
            },
            { text: '** Important Notes: 1) List Price is Indicative Only. 2) Ex-Stock Prior to Sales'},
            { text: '\n' },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  table: {
                    body: [
                      [
                        { text: 'Subtotal:', alignment: 'right', bold: true },
                        { text: `$${this.formatter(this.calculateTotal.subTotal)}`, alignment: 'right' }
                      ],
                      [
                        { text: `GST ${this.currentGST.value}%:`, alignment: 'right', bold: true },
                        { text: `$${this.formatter(this.calculateTotal.totalGST)}`, alignment: 'right' }
                      ],
                      [
                        { text: 'Grand Total:', alignment: 'right', bold: true },
                        { text: `$${this.formatter(this.calculateTotal.grandTotal)}`, alignment: 'right', bold: true }
                      ]
                    ]
                  },
                  layout: 'noBorders'
                }
              ],
              margin: [0, 20, 0, 0]
            }
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              alignment: 'center'
            },
            subheader: {
              fontSize: 14,
              bold: true,
              margin: [0, 10, 0, 5]
            },
            tableHeader: {
              bold: true,
              fontSize: 10,
              fillColor: '#f8f9fa'
            }
          }
        };

        if (pdfMake.vfs === undefined) {
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }

        let fileName = `PO-${this.poNumber[0]}`;
        pdfMake.createPdf(docDefinition).download(fileName);
      } catch (error) {
        console.error('Error generating PDF:', error);
        this.$bvToast.toast('Error generating PDF', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
    async resendKioskPO() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("purchase/resendKioskPO", {
          poNumber: this.poNumber[0]
        });
        
        if (response.data.success) {
          this.$bvToast.toast('PO has been successfully resent', {
            title: 'Success',
            variant: 'success',
            solid: true
          });
          
          // Refresh purchase data
          await this.fetchPurchaseData();
        } else {
          this.$bvToast.toast(`Failed to resend PO: ${response.data.apiResult.message || 'Unknown error'}`, {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.error('Error resending PO:', error);
        this.$bvToast.toast('Error resending PO. Please try again later.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loading = false;
      }
    },
    confirmPO(){
      // ini waktu klik confirm purchase dimana akan kirim PO ke SAP. dengan sebelumnya akan check stock dulu per item
      // for handling dealer info
      this.disableButton = true;

      
      // this industryType
      let mFormCopy = JSON.parse(JSON.stringify(this.purchase));
      mFormCopy.customer = mFormCopy.customerDetail
      if (mFormCopy.items.length <= 0) {
        this.$bvToast.toast("Please Add Item First", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        return;
      }

      
      this.addSaleKiosk(mFormCopy)
        .then(async (response) => {
          
          if(!response.data.success){
            this.disableButton = false;
            this.modalSubmitPO = false;
            this.$bvToast.toast("Submit Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
            // Show the error modal instead of toast and redirecting immediately
            this.modalSapError = true;
            return;
          }

          this.disableButton = false;
          this.modalSubmitPO = false;
          this.$bvToast.toast("Submit Kiosk Purchase Order Successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
        })
        .catch(async (e) => {
          this.disableButton = false;
          this.modalSubmitPO = false;
          this.$bvToast.toast("Submit Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          await sleep(2000);
        });
    },
    async cancelPO() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("purchase/editStatusKioskPo", {
          id: this.id,
          data: { orderStatus: "Canceled" }
        });
        
        if (response.data && response.data.success) {
          this.$bvToast.toast('PO has been successfully canceled', {
            title: 'Success',
            variant: 'success',
            solid: true
          });
          
          // Refresh purchase data
          await this.fetchPurchaseData();
        } else {
          this.$bvToast.toast('Failed to cancel PO', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.error('Error canceling PO:', error);
        this.$bvToast.toast('Error canceling PO. Please try again later.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loading = false;
        this.showCancelModal = false;
      }
    },
    displayPaymentType(type) {
      switch(type) {
        case 'CASH':
          return 'Paynow';
        case 'MC':
          return 'Credit Card Master Card';
        case 'VISA':
          return 'Credit Card Visa';
        case 'NETS':
          return 'Nets';
        default:
          return 'N/A';
      }
    },
  },
  computed: {
    ...mapGetters({
      itemsOptions: "item/itemsOptions",
      itemsBundles: "item/itemsBundles",
      currentGST: "GST/getCurrentGST",
    }),
    // deliveryOrders() {
    //   return this.$store.getters["delivery/getDO"];
    // },
    purchase() {
      return this.$store.getters["purchase/purchaseById"];
    },
    poNumber(){
      if(this.purchase.length<=0){
        return ["",""]
      }
      var split = this.purchase.PONumber.split("*");
      return split;
    },
    salesOrders() {
      return this.$store.getters["sales/sales"];
    },
    permission() {
      let result = userAccess("Kiosk PO", "order_menu");
      // console.log("Order",result)
      return result;
    },
    showPrintButton() {
      const status = this.purchase.orderStatus;
      //don't show if Pending, Draft or PO Fail
      return status && !['Pending', 'Draft', 'PO Fail'].includes(status);
    },
    calculateTotal(){
      const data = this.purchase.items;
      let baseTotalPrice = data.reduce((acc, item) => {
        const details = this.getItemDetails(item);
        return acc + (details.price * details.qty);
      }, 0);

      const subTotal = data.reduce((acc, item) => {
        const details = this.getItemDetails(item);
        return acc + details.totalPrice;
      }, 0);

      const totalDiscount = (((baseTotalPrice - subTotal) / baseTotalPrice) * 100).toFixed(2);
      const totalGST = subTotal * this.currentGST.value / 100;
      const grandTotal = (subTotal + totalGST).toFixed(2);
      
      return {
        subTotal,
        totalDiscount,
        totalGST,
        grandTotal
      }
    },
    checkingProgress() {
      if (!this.purchase || !this.purchase.items) {
        return { checked: 0, total: 0 };
      }
      
      const total = this.purchase.items.length;
      const checked = this.purchase.items.filter(item => 
        item.status && item.status !== 'Checking Stock'
      ).length;
      
      return {
        checked,
        total
      };
    },
    showStatusModal() {
      if (!this.purchase || !this.purchase.orderStatus) return false;

      if(this.purchase.orderStatus === 'Processing SO' && this.purchase.PONumber.includes('EKR')){
        return true;
      }

      return ['Awaiting Discount Approval', 'Checking','Editing'].includes(this.purchase.orderStatus);
    },
    
    statusModalTitle() {
      if (!this.purchase || !this.purchase.orderStatus) return '';
      
      switch(this.purchase.orderStatus) {
        case 'Awaiting Discount Approval':
          return 'Discount Approval Required';
        case 'Checking':
          return 'Stock Check in Progress';
        case 'Processing SO':
          return 'Sales Order is successfully created in SAP';
        case 'Editing':

          if(this.purchase.approvalToken === 'rejected'){
            return 'Discount Request Rejected'
          }
          return 'Received Edit PO Request'
        default:
          return 'Status Update';
      }
    },
    
    statusModalMessage() {
      if (!this.purchase || !this.purchase.orderStatus) return '';
      
      switch(this.purchase.orderStatus) {
        case 'Awaiting Discount Approval':
          return 'Currently waiting for Discount Approval. Please wait.';
        case 'Checking':
          return 'Warehouse is checking for stock. Please Wait.';
        case 'Processing SO':
          return 'Sales Order is successfully created in SAP';
        case 'Editing':
        if(this.purchase.approvalToken === 'rejected'){
            return 'Discount request is rejected. Please edit PO discount accordingly.'
          }
          return 'Warehouse team request to edit PO, please check if the item is the correct model';
        default:
          return '';
      }
    },
    
    showSpinner() {
      if (!this.purchase || !this.purchase.orderStatus) return false;
      return ['Awaiting Discount Approval', 'Checking'].includes(this.purchase.orderStatus);
    }
  },
  mounted() {
    this.$store.dispatch("sales/getSales", { orderStatus: "ALL" });
    
    
    // Initial data fetch
    this.fetchPurchaseData();
    
    // Start auto refresh
    this.startAutoRefresh();
  },
  beforeDestroy() {
    // Clean up the interval when component is destroyed
    this.$store.dispatch("purchase/resetPurchaseById")
    this.clearRefreshInterval();
  },
  beforeRouteLeave(to, from, next) {
    // Clean up the interval when navigating away
    this.clearRefreshInterval();
    next();
  }
};
</script>
